export const defaultCircle = [
    {
        radius: 100000,
        center: {
            lat: 52.191111,
            lng: 19.355417
        },
        pathOptions: {
            color: "rgba(0,0,0,0)",
            opacity: 0
        }
    }
];
export const defaultCircle = [
    {
        radius: 100000,
        center: {
            lat: 52.191111,
            lng: 19.355417
        },
        pathOptions: {
            color: "rgba(0,0,0,0)",
            opacity: 0
        }
    }
];
